var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEth = function SvgEth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#667ED6",
    d: "m6.406 1-.073.247v7.169l.073.072 3.327-1.967-3.327-5.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8198EE",
    d: "M6.406 1 3.078 6.522l3.328 1.967V1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#667ED6",
    d: "m6.406 9.572-.041.05v2.553l.04.12 3.33-4.69-3.329 1.967Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8198EE",
    d: "M6.406 12.295V9.572L3.078 7.606l3.328 4.689ZM6.406 8.49l3.327-1.968L6.406 5.01v3.48Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#667ED6",
    d: "M3.078 6.522 6.406 8.49V5.01L3.078 6.523Z"
  })));
};
export default SvgEth;